export const PortalDocuments = "PortalDocuments/";
export const UploadDocument = PortalDocuments + 'UploadDocument';
export const GetDocumentTypesForSection = PortalDocuments + 'GetDocumentTypesForSection';
export const GetDocumentsUploaded = PortalDocuments + 'GetDocumentsUploaded';
